import { Injectable } from "@angular/core";
import { MatLegacyDialog } from "@angular/material/legacy-dialog";
import { PaymentsEditComponent } from "./payments-edit/payments-edit.component";
import { PaymentsEditConfiguration } from "./payments-edit/payments-edit.configuration";

@Injectable({ providedIn: 'root' })
export class PaymentsService{


    constructor( private dialog: MatLegacyDialog){}

    openForm(param: PaymentsEditConfiguration | null = null): Promise<void> {
        return new Promise((resolve, reject) => {
          const dialogRef = this.dialog.open(PaymentsEditComponent, {
            data: param
          });
    
          dialogRef.afterClosed().subscribe(result => {
            resolve();
          }, error => {
            reject(error);
          });
        });
      }
    
}